export const CUSTOM_FORMATS = {
    date: {
        // eg: May 22, 2019, 2:27 PM
        longDateTime: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        },
    },
};
